// extracted by mini-css-extract-plugin
module.exports = {"container":"DeviceList_container__2-HO6"};